import { Check, Gift, Sparkles } from "lucide-react";
import { RECURRING_PROMISE, FIRST_CLEAN_OFFER } from "@/data/site";

export const OfferBanner = ({ offer, className = "" }) => (
  <div className={`flex items-center gap-3 rounded-2xl bg-leaf/10 border border-leaf/30 p-4 ${className}`} data-testid="first-clean-offer">
    <span className="w-9 h-9 rounded-full bg-leaf/15 flex items-center justify-center shrink-0"><Gift className="w-4 h-4 text-leaf" /></span>
    <p className="text-sm font-medium text-navy">{offer || FIRST_CLEAN_OFFER}</p>
  </div>
);

// variant="card" → compact block for modals; variant="section" → full page section.
export const RecurringPromise = ({ variant = "card", promise, className = "" }) => {
  const { title, intro, items, fineprint } = promise || RECURRING_PROMISE;

  if (variant === "section") {
    return (
      <section className={`py-24 md:py-32 bg-muted/50 ${className}`} data-testid="recurring-promise-section">
        <div className="max-w-5xl mx-auto px-5 sm:px-8">
          <div className="max-w-2xl mb-10">
            <p className="text-xs uppercase tracking-[0.25em] text-leaf mb-4 flex items-center gap-2"><Sparkles className="w-3.5 h-3.5" /> Recurring Plans</p>
            <h2 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-navy leading-none">{title}</h2>
            <p className="mt-5 text-lg text-muted-foreground">{intro}</p>
          </div>
          <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-4">
            {items.map((it) => (
              <li key={it} className="flex items-start gap-3">
                <span className="w-6 h-6 rounded-full bg-leaf/15 flex items-center justify-center shrink-0 mt-0.5"><Check className="w-3.5 h-3.5 text-leaf" /></span>
                <span className="text-navy leading-relaxed">{it}</span>
              </li>
            ))}
          </ul>
          <div className="mt-8 space-y-1">
            {fineprint.map((f) => <p key={f} className="text-xs text-muted-foreground leading-relaxed">{f}</p>)}
          </div>
        </div>
      </section>
    );
  }

  return (
    <div className={`rounded-2xl border border-leaf/30 bg-leaf/5 p-4 ${className}`} data-testid="recurring-promise-card">
      <p className="font-heading text-base font-semibold text-navy flex items-center gap-2"><Sparkles className="w-4 h-4 text-leaf" /> {title}</p>
      <p className="text-xs text-muted-foreground mt-1">{intro}</p>
      <ul className="mt-3 space-y-1.5">
        {items.map((it) => (
          <li key={it} className="flex items-start gap-2 text-sm text-navy"><Check className="w-3.5 h-3.5 text-leaf shrink-0 mt-1" /><span>{it}</span></li>
        ))}
      </ul>
      <div className="mt-3 space-y-0.5">
        {fineprint.map((f) => <p key={f} className="text-[10px] leading-snug text-muted-foreground">{f}</p>)}
      </div>
    </div>
  );
};
